import { render, staticRenderFns } from "./Onay.vue?vue&type=template&id=387e199c"
import script from "./Onay.vue?vue&type=script&lang=js"
export * from "./Onay.vue?vue&type=script&lang=js"
import style0 from "./Onay.vue?vue&type=style&index=0&id=387e199c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports